module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"kpindex":"Kp Index","refresh":"Refresh","days":"Days count"},"ru":{"kpindex":"Kp индекс","refresh":"Обновить","days":"Отображать дней"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/kpindex.vue
// module id = 762
// module chunks = 0